export default "__VITE_ASSET__DsTLfUww__"